import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import 'shared/i18n/i18n';
import 'shared/utils/setntry-instrument.js';
import { Web3StackProvider } from 'shared/web3/web3-stack-provider';

import App from './app/App';
import './index.css';
import { AnalyticsLoader } from './lib/AnalyticsLoader/AnalyticsLoader';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
  <StrictMode>
    <Web3StackProvider>
      <Router>
        <AnalyticsLoader />
        <App />
      </Router>
    </Web3StackProvider>
  </StrictMode>,
);
